export function validateAddToWinner() {
  return [true, ''];
}
